import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import ValidateBusinessActivityModal from './ValidateBusinessActivityModal';
import * as c from '../../constant';
import * as actions from '../../actions';

function BusinessActivity({
  businessId,
  getBusinessActivityList,
  businessActivityList,
  validateBusinessActivity,
}) {
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');
  const [grossAmount, setGrossAmount] = useState({});
  const [formDataQuantityMatrix, setFormDataQuantityMatrix] = useState({});

  const onValidateBusinessActivity = (data) => (e) => {
    e.preventDefault();

    setViewUpdateForm(true, setFormData(data));
  };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
  };

  const handleValidateBusinessActivity = (data) => (e) => {
    e.preventDefault();

    const businessActivityId = _.get(formData, 'id');
    const details = _.omit(data, 'business_line_id');
    const businessNecessary = {
      ...details,
      quantity_matrix: formDataQuantityMatrix
    }

    ConfirmAlert(
      'Are you sure you want to validate this business activity?',
      () => {
        const args = {
          details: businessNecessary,
          gross_amount: _.get(grossAmount, 'gross_amount', '') || 0,
        };
        validateBusinessActivity(businessId, businessActivityId, args, () => {
          setViewUpdateForm(false);
          getBusinessActivityList(businessId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const existingBusinessActivityList = 
  (businessActivityList || []).filter(
    (item) => !_.get(item, 'attributes.is_new_addition', 0)
  )
  
  return (
    <div>
      <div className="row">
        <div className="col-12">
          {viewUpdateForm && (
            <ValidateBusinessActivityModal
              closeUpdateModal={closeUpdateModal}
              businessActivityInfo={formData}
              handleValidateBusinessActivity={handleValidateBusinessActivity}
              setViewUpdateForm={setViewUpdateForm}
              businessId={businessId}
              grossAmount={grossAmount}
              setGrossAmount={setGrossAmount}
              formDataQuantityMatrix={formDataQuantityMatrix}
              setFormDataQuantityMatrix={setFormDataQuantityMatrix}
            />
          )}
        </div>
      </div>

      {!viewUpdateForm && (
        <div className="row">
          {existingBusinessActivityList.map((item) => {
            return (
              <div key={item.id} className="col-6 form-group">
                <div className="form-wrapper p-3">
                  <div className="text-right">
                    <button
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary    "
                      type="button"
                      onClick={onValidateBusinessActivity(item)}
                    >
                      Validate
                    </button>
                  </div>
                  <div className="">
                    <label className="text-primary font-weight-bold mr-2">
                      Name:
                    </label>
                    <b>{_.get(item, 'attributes.name')}</b>
                  </div>
                  <div className="">
                    <label className="text-primary font-weight-bold mr-2">
                      Status:
                    </label>
                    <b>
                      {_.get(item, 'attributes.is_validated')
                        ? 'Validated'
                        : 'For Validation'}
                    </b>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

BusinessActivity.propTypes = {
  businessId: PropTypes.string.isRequired,
  getBusinessActivityList: PropTypes.instanceOf(Function).isRequired,
  businessActivityList: PropTypes.instanceOf(Array).isRequired,
  validateBusinessActivity: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessActivity);
